import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form"]
  
  connect() {
  }
  
  open(event) {
    event.preventDefault()
    this.showModal()
  }

  close() {
    this.hideModal()
  }

  submit(event) {
    event.preventDefault()
    
    const formData = new FormData(this.formTarget)
    
    // 送信中の状態を表示
    const submitButton = this.formTarget.querySelector('input[type="submit"]')
    const originalText = submitButton.value
    submitButton.value = "送信中..."
    submitButton.disabled = true
    
    // メール送信のAPIコール（実際の実装では適切なエンドポイントを使用）
    fetch('/companies_search/contact', {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => {
      if (response.ok) {
        alert('お問い合わせを送信しました。ありがとうございます。')
        this.formTarget.reset()
        this.hideModal()
      } else {
        throw new Error('送信に失敗しました')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('送信中にエラーが発生しました。しばらく後に再度お試しください。')
    })
    .finally(() => {
      submitButton.value = originalText
      submitButton.disabled = false
    })
  }

  showModal() {
    if (this.modalTarget) {
      this.modalTarget.classList.remove('hidden')
      document.body.style.overflow = 'hidden'
      
      // フォーカスを最初の入力フィールドに設定
      const firstInput = this.formTarget.querySelector('input, textarea')
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100)
      }
    } else {
      console.error("Modal target not found!")
    }
  }

  hideModal() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  // ESCキーでモーダルを閉じる
  keydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
